// client/src/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

const ProtectedRoute = ({ children, allowedUserTypes }) => {
  const { isLoggedIn, userType } = useAuth();

  // Redirect based on userType if not logged in
  const getRedirectPath = () => {
    if (!isLoggedIn) {
      return userType === "employee" ? "/employee-login" : "/login";
    }
    return null;
  };

  return isLoggedIn && allowedUserTypes.includes(userType) ? (
    children
  ) : (
    <Navigate to={getRedirectPath()} replace />
  );
};

export default ProtectedRoute;
